import React from 'react';
import SharedDetails from '../../Components/SharedDetails/SharedDetails';

const columns = [
  { title: 'Item Number', field: 'ItemNumber' },
  { title: 'Item Name', field: 'ItemName' },
  { title: 'Vendor Name', field: 'VendorName' },
  { title: 'Quantity', field: 'Quantity', type: 'numeric' },
  { title: 'Reserve', field: 'Reserve', type: 'numeric' },
];

const csvHeaders = [
  { label: 'Item Number', key: 'ItemNumber' },
  { label: 'Item Name', key: 'ItemName' },
  { label: 'Vendor Name', key: 'VendorName' },
  { label: 'Quantity', key: 'Quantity' },
  { label: 'Reserve', key: 'Reserve' },
];

const ItemDetails = () => (
  <SharedDetails
    columns={columns}
    csvFilename="item-details.csv"
    csvHeaders={csvHeaders}
    emptyMessage="No item records found."
    pagedEndpoint="/api/get/item/paged"
    responseDataKey="items"
    errorMessage="Unable to load item details. Please try again."
    loadingMessage="Loading items..."
    title="Item Details"
  />
);

export { ItemDetails };
export default ItemDetails;
